export default __webpack_public_path__ + "static/media/6.e17abae9.jpg";